import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

// i18n
import './lib/i18n/i18n';

import 'leaflet/dist/leaflet.css';

// Tailwind css
import './tailwind.css';

// Router
import { RouterProvider } from 'react-router-dom';
import './lib/axios/axios-global';
import router from './core/global-router';
import { Provider } from 'react-redux';
import store from './core/global-store';
import LangSettings from './lib/i18n/LangSettings';
import { Toaster } from './components/ui/sonner';
import { AppBrandingProvider } from './contexts/AppBrandingContext';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
        <LangSettings>
            <AppBrandingProvider>
                <Suspense>
                    <RouterProvider router={router} />
                    <Toaster />
                </Suspense>
            </AppBrandingProvider>
        </LangSettings>
    </Provider>,
);
